import React from "react";
import styled from "styled-components";

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 40px 24px 80px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  color: #222;
  line-height: 1.7;
`;

const Title = styled.h1`
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 8px;
`;

const Updated = styled.p`
  color: #888;
  font-size: 14px;
  margin-bottom: 40px;
`;

const Section = styled.section`
  margin-bottom: 32px;
`;

const H2 = styled.h2`
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 12px;
`;

const P = styled.p`
  font-size: 15px;
  margin-bottom: 12px;
`;

const Ul = styled.ul`
  padding-left: 20px;
  margin-bottom: 12px;
  li {
    font-size: 15px;
    margin-bottom: 6px;
  }
`;

const Privacy = () => {
  return (
    <Container>
      <Title>개인정보 처리방침</Title>
      <Updated>시행일: 2026년 3월 11일</Updated>

      <Section>
        <P>
          DP Wallet(이하 "회사")은 「개인정보 보호법」 등 관련 법령에 따라 이용자의 개인정보를 보호하고,
          이와 관련한 고충을 신속하고 원활하게 처리하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다.
        </P>
      </Section>

      <Section>
        <H2>1. 수집하는 개인정보 항목</H2>
        <Ul>
          <li>필수 항목: 이메일 주소, 비밀번호(암호화 저장), 휴대전화번호</li>
          <li>자동 수집 항목: 접속 IP, 접속 일시, 서비스 이용 기록, 기기 정보(OS, 브라우저 유형, 앱 버전)</li>
        </Ul>
      </Section>

      <Section>
        <H2>2. 개인정보의 수집 및 이용 목적</H2>
        <Ul>
          <li>회원 가입 및 본인 인증</li>
          <li>서비스 제공 및 운영</li>
          <li>고객 문의 응대 및 공지사항 전달</li>
          <li>부정이용 방지 및 서비스 안정성 확보</li>
          <li>서비스 개선을 위한 통계 분석</li>
        </Ul>
      </Section>

      <Section>
        <H2>3. 개인정보의 보유 및 이용 기간</H2>
        <P>
          회사는 개인정보 수집 및 이용 목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다.
          단, 관련 법령에 의해 보존이 필요한 경우 아래 기간 동안 보관합니다.
        </P>
        <Ul>
          <li>계약 또는 청약철회 등에 관한 기록: 5년 (전자상거래법)</li>
          <li>소비자 불만 또는 분쟁처리에 관한 기록: 3년 (전자상거래법)</li>
          <li>접속 로그 기록: 3개월 (통신비밀보호법)</li>
        </Ul>
      </Section>

      <Section>
        <H2>4. 개인정보의 제3자 제공</H2>
        <P>
          회사는 원칙적으로 이용자의 개인정보를 외부에 제공하지 않습니다.
          다만, 이용자가 사전에 동의한 경우 또는 법령에 의해 요구되는 경우는 예외로 합니다.
        </P>
      </Section>

      <Section>
        <H2>5. 개인정보의 안전성 확보 조치</H2>
        <Ul>
          <li>비밀번호 암호화 저장</li>
          <li>SSL/TLS를 통한 전송 구간 암호화</li>
          <li>접근 권한 관리 및 접속 기록 보관</li>
          <li>개인정보 취급 직원 최소화</li>
        </Ul>
      </Section>

      <Section>
        <H2>6. 이용자의 권리</H2>
        <P>이용자는 언제든지 개인정보 열람, 정정, 삭제, 처리정지를 요구할 수 있으며, 회원 탈퇴를 요청할 수 있습니다.</P>
        <P>위 요청은 앱 내 설정 또는 고객센터(DWTdp1@gmail.com)를 통해 할 수 있습니다.</P>
      </Section>

      <Section>
        <H2>7. 개인정보 보호책임자</H2>
        <Ul>
          <li>이메일: DWTdp1@gmail.com</li>
        </Ul>
      </Section>

      <Section>
        <H2>8. 개인정보 처리방침의 변경</H2>
        <P>
          본 방침은 시행일로부터 적용되며, 변경사항이 있을 경우 시행 7일 전부터 공지사항을 통해 고지합니다.
        </P>
      </Section>
    </Container>
  );
};

export default Privacy;
